<template>
  <div>
    <el-table v-bind="$attrs" v-on="$listeners" v-loading="tableloading" :data="tableData" border height="auto" @header-dragend="dragend" :cell-class-name="tableCellClassName" v-drag @changPress="changPress" @cell-mouse-enter="cellMouse" @selection-change="handleSelectionChange" ref="elTableAuto" :row-class-name="tableRowClassName" @row-click="rowClick" v-contextmenu:contextmenu>
      <el-table-column type="index" align="center" width="50">
        <template #header>
          <!-- <i class="el-icon-s-tools" @click="opentransfer"></i> -->
        </template>
      </el-table-column>
      <el-table-column v-if="isCheck" type="selection" align="center" width="50">
      </el-table-column>
      <template v-for="(item, index) in configs">
        <template v-if="!item.hide">
          <el-table-column :key="index" v-if="item.expand" :label="item.label" :width="item.width">
            <template v-slot="{ row }">
              <slot :name="item.template" :row="row" :prop="row"></slot>
            </template>
          </el-table-column>
          <el-table-column :key="index" v-if="item.template" :label="item.label" :width="item.width">
            <template v-slot="{ row }">
              <slot :name="item.template" :row="row" :prop="row"></slot>
            </template>
          </el-table-column>
          <el-table-column :key="index" v-else :label="item.label" :prop="item.prop" :formatter="item.formatter" :width="item.width" :show-overflow-tooltip="true"></el-table-column>
        </template>
      </template>
      <el-table-column type="expand" :width="1">
        <template v-slot="{ row }">
          <slot name="expand" :row="row" :prop="row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="设置" :visible.sync="tools" class="scdialog">
      <el-transfer v-model="transfer" :data="transferList" :titles="['未显示', '已显示']" filterable>
        <div slot-scope="{ option }">
          <div style="display: inline-block; width: 120px">
            {{ option.label }}
          </div>
          <el-button icon="el-icon-arrow-up" @click="upclick(option.key)"></el-button>
          <el-button icon="el-icon-arrow-down" @click="downclick(option.key)"></el-button>
        </div>
      </el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tools = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <div class="pagination">
      <div class='paginationtip'>提示：可使用Shift键进行多选</div>
      <el-pagination v-if="isPage" background layout="total, sizes, prev, pager, next" :current-page="pageNum" :page-size="pageSize" :total="count" @size-change="sizeChange" @current-change="currentChange" />
    </div>
    <v-contextmenu ref="contextmenu" theme="default" style="z-index: auto">
      <v-contextmenu-item @click="copyclick">复制</v-contextmenu-item>
    </v-contextmenu>
  </div>
</template>

<script>
import { export_json_to_excel } from '@/vendor/Export2Excel'
export default {
  directives: {
    drag: {
      inserted: (el, binding, vnode) => {
        el.onmousedown = (e) => {
          if (e.button != 0) return //0为鼠标左键
          vnode.child.$emit('changPress', true)
          document.onmouseup = () => {
            vnode.child.$emit('changPress', false)
          }
        }
      }
    }
  },
  props: {
    id: {
      type: String,
      required: true,
      desc: '本地保存配置使用的表名'
    },
    name: {
      type: String,
      required: true,
      desc: '导出数据文件名'
    },
    column: {
      type: Array,
      required: true,
      desc: '表格配置'
    },
    isCheck: {
      type: Boolean,
      default: true,
      desc: '是否多选'
    },
    isData: {
      type: Boolean,
      default: false,
      desc: '传递数据还是函数调用'
    },
    tableHandData: {
      type: Array,
      default: () => [],
      desc: '表格数据'
    },
    tableHand: {
      type: Function,
      default: () => ({ list: [], total: 0 }),
      desc: '查询表格数据'
    },
    isPage: {
      type: Boolean,
      default: true,
      desc: '关闭分页多选'
    },
    isSubData: {
      type: Boolean,
      default: false,
      desc: '子表传递数据还是函数调用'
    },
    subtableHandData: {
      type: Array,
      default: () => [],
      desc: '子表表格数据'
    },
    subtableHand: {
      type: Function,
      default: () => ({ list: [], total: 0 }),
      desc: '子表查询表格数据'
    },
    downHand: {
      type: Function,
      default: () => {},
      desc: '导出复制字段数据'
    }
  },
  data: () => ({
    // 配置
    configs: [],
    // 按键
    keyBoard: {},
    isActivated: false,
    // 设置
    tools: false,
    transfer: [],
    transferList: [],
    // 范围
    crrCell: [],
    press: false,
    startCell: [],
    endCell: [],
    start: [],
    end: [],
    fwrow: false,
    fwcolumn: false,
    // 多选
    multipleSelection: [],
    // 分页
    tableloading: false,
    tableData: [],
    pageNum: 1,
    pageSize: 20,
    count: 0
  }),
  mounted() {
    this.initConf()
    this.initKeyBoard()
    this.submitForm()
  },
  activated() {
    this.isActivated = true
  },
  deactivated() {
    this.isActivated = false
  },
  methods: {
    // 配置初始化表格
    initConf() {
      let COLUMN_WIDTH = localStorage.getItem('COLUMN_WIDTH')
      let COLUMN_HIDE = localStorage.getItem('COLUMN_HIDE') || '{"questions":["serviceStatus"]}'
      let COLUMN_SORT = localStorage.getItem('COLUMN_SORT')
      // let COLUMN_WIDTH = null
      // let COLUMN_HIDE = '{"questions":["serviceStatus"]}'
      // let COLUMN_SORT = null
      let confs = [...this.column]
      // confs.forEach((conf) => {
      //   if (COLUMN_WIDTH) {
      //     let widthobj = JSON.parse(COLUMN_WIDTH)[this.id]
      //     if (widthobj) {
      //       if (widthobj[conf.template || conf.prop]) {
      //         conf.width = widthobj[conf.template || conf.prop]
      //       }
      //     }
      //   }
      //   if (COLUMN_HIDE) {
      //     let hidelist = JSON.parse(COLUMN_HIDE)[this.id]
      //     if (hidelist) {
      //       if (hidelist.indexOf(conf.template || conf.prop) > -1) {
      //         conf.hide = true
      //       } else {
      //         conf.hide = false
      //       }
      //     }
      //   }
      // })
      // if (COLUMN_SORT) {
      //   let sortobj = JSON.parse(COLUMN_SORT)[this.id]
      //   if (sortobj) {
      //     confs.sort((a, b) => {
      //       if (!a.type && !b.type) {
      //         let a_index = sortobj.indexOf(a.template || a.prop)
      //         let b_index = sortobj.indexOf(b.template || b.prop)
      //         return a_index - b_index
      //       }
      //       return 0
      //     })
      //   }
      // }
      this.configs = confs
    },
    // 初始化按键
    initKeyBoard() {
      document.addEventListener('keydown', (e) => {
        this.keyBoard[e.key] = true
        this.onkeydown()
      })
      document.addEventListener('keyup', (e) => {
        this.keyBoard[e.key] = false
      })
    },
    // 宽度存储
    dragend(newWidth, oldWidth, column, event) {
      let COLUMN_WIDTH = localStorage.getItem('COLUMN_WIDTH')
      COLUMN_WIDTH = JSON.parse(COLUMN_WIDTH)
      if (!COLUMN_WIDTH) COLUMN_WIDTH = {}
      let WIDTH = COLUMN_WIDTH[this.id]
      if (!WIDTH) {
        COLUMN_WIDTH = { ...COLUMN_WIDTH, [this.id]: {} }
        WIDTH = COLUMN_WIDTH[this.id]
      }
      let conf = this.configs.find((item) => item.label == column.label)
      WIDTH[conf.template || conf.prop] = newWidth
      localStorage.setItem('COLUMN_WIDTH', JSON.stringify(COLUMN_WIDTH))
    },
    // 鼠标左键按下或松开
    changPress(flog) {
      this.press = flog
      if (this.press) {
        this.endCell = this.startCell = this.crrCell
      }
    },
    // 移动进入单元格
    cellMouse(row, column, cell, event) {
      this.crrCell = [row, column, cell, event]
      if (this.press) {
        this.endCell = this.crrCell
      }
    },
    // // 单元格类名
    // tableCellClassName({ row, column, rowIndex, columnIndex }) {
    //   let rowflog = false
    //   let columnflog = false
    //   // 一个格
    //   if(this.startCell[0] == row && this.endCell[0] == row){
    //     rowflog = true
    //   }
    //   if(this.startCell[1] === column && this.endCell[1] == column){
    //     columnflog = true
    //   }
    //   // 多个格
    //   if(!rowflog){
    //     if(this.startCell[0] == row || this.endCell[0] == row){
    //       // this.fwrow = !this.fwrow
    //     }
    //     if(this.fwrow){
    //       rowflog = true
    //     }
    //   }
    //   if(!columnflog){
    //     if(this.startCell[1] === column || this.endCell[1] == column){
    //       // this.fwcolumn = !this.fwcolumn
    //     }
    //     if(this.fwcolumn){
    //       columnflog = true
    //     }
    //   }
    //   if(rowflog && columnflog){
    //     return 'select'
    //   }
    // },
    // 单元格类名
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (this.start.length && this.end.length) {
        if (this.numflog(rowIndex, this.start[0], this.end[0]) && this.numflog(columnIndex, this.start[1], this.end[1])) {
          // 这里选择行
          // if(this.isCheck)this.toggleRowSelection(row, true)
          return 'select'
        }
      }
      if (this.startCell.length && this.endCell.length) {
        if (this.startCell[0] == row && this.startCell[1] == column) {
          this.start = [rowIndex, columnIndex]
        }
        if (this.endCell[0] == row && this.endCell[1] == column) {
          this.end = [rowIndex, columnIndex]
        }
      }
    },
    //  判断是否在区间
    numflog(crr, start, end) {
      if (crr !== '' && start !== '' && end !== '') {
        if ((start <= crr && crr <= end) || (end <= crr && crr <= start)) {
          return true
        }
      }
    },
    // 复制
    onkeydown() {
      if (this.keyBoard['Control'] && this.keyBoard['c'] && this.isActivated) {
        this.copyclick()
      }
    },
    // 复制选中单元格
    copyclick() {
      let copyText = ''
      for (let indexrow = 0; indexrow < this.tableData.length; indexrow++) {
        if (this.numflog(indexrow, this.start[0], this.end[0])) {
          let rowtext = ''
          for (let indxcolumn = 0; indxcolumn < this.configs.length; indxcolumn++) {
            let crr = indxcolumn + (this.isCheck ? 2 : 1)
            if (this.numflog(crr, this.start[1], this.end[1])) {
              let columntext = ''
              if (this.configs[indxcolumn].template) {
                columntext = this.downHand(this.tableData[indexrow], this.configs[indxcolumn].template) || this.tableData[indexrow][this.configs[indxcolumn]['template']]
              } else {
                columntext = this.tableData[indexrow][this.configs[indxcolumn]['prop']]
              }
              if (columntext) {
                if (rowtext) {
                  rowtext += ' '
                }
                rowtext += columntext
              }
            }
          }
          if (rowtext) {
            if (copyText) {
              copyText += '\n'
            }
            copyText += rowtext
          }
        }
      }
      this.$copyText(copyText)
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 范围多选
    rowClick(row) {
      if (this.keyBoard['Shift'] && this.multipleSelection.length && this.multipleSelection[this.multipleSelection.length - 1] != row) {
        // shift+click
        let flogVal = [this.multipleSelection[this.multipleSelection.length - 1], row]
        console.log(flogVal)
        this.toggleRowSelection(row, true)
        let flog = false
        this.tableData.forEach((row) => {
          if (flogVal.indexOf(row) > -1) {
            flog = !flog
          }
          if (flog) {
            this.toggleRowSelection(row, true)
          }
        })
      } else {
        this.clearSelection()
        this.toggleRowSelection(row)
      }
    },
    // 清空行复选框
    clearSelection() {
      this.$refs.elTableAuto.clearSelection()
    },
    // 行复选框选中取消
    toggleRowSelection(...vars) {
      this.$refs.elTableAuto.toggleRowSelection(...vars)
    },
    // 行收缩展开
    toggleRowExpansion(...vars) {
      this.$refs.elTableAuto.toggleRowExpansion(...vars)
    },
    // 行类名
    tableRowClassName({ row }) {
      if (this.multipleSelection.includes(row)) {
        return 'select'
      }
    },
    // ----------------------------
    // 打开设置
    opentransfer() {
      this.transferList = this.configs.map((crr) => ({
        key: crr.template || crr.prop,
        label: crr.label
      }))
      this.transfer = this.configs.filter((item) => !item.hide).map((crr) => crr.template || crr.prop)
      this.tools = true
    },
    upclick(key) {
      let index = this.transferList.findIndex((item) => item.key == key)
      if (index <= 0) return
      this.transferList.splice(index - 1, 1, this.transferList.splice(index, 1, this.transferList[index - 1])[0])
      this.transferList = [...this.transferList]
      let val1 = this.transferList[index - 1]
      let val2 = this.transferList[index]
      let subset = this.difference(this.difference(this.transfer, [val1.key]), [val2.key])
      if (this.transfer.length - subset.length == 1) {
        //如果交换顺序的两个项分别在两边操作栏，那么讲继续传递执行
        this.upclick(val1.key)
      }
    },
    downclick(key) {
      let index = this.transferList.findIndex((item) => item.key == key)
      if (index >= this.transferList.length - 1) return
      this.transferList.splice(index + 1, 1, this.transferList.splice(index, 1, this.transferList[index + 1])[0])
      this.transferList = [...this.transferList]
      let val1 = this.transferList[index + 1]
      let val2 = this.transferList[index]
      let subset = this.difference(this.difference(this.transfer, [val1.key]), [val2.key])
      if (this.transfer.length - subset.length == 1) {
        //如果交换顺序的两个项分别在两边操作栏，那么讲继续传递执行
        this.downclick(val1.key)
      }
    },
    // 过滤数组差集
    difference(all, part) {
      var all = new Set(all)
      var part = new Set(part)
      var subset = []
      for (let item of all) {
        if (!part.has(item)) {
          subset.push(item)
        }
      }
      return subset
    },
    confirm() {
      this.tools = false
      // 所有可操作列数组中去掉选中列数组
      let transferList = this.transferList.map((crr) => crr.key)
      let hide = this.difference(transferList, this.transfer)
      this.upcolumn(hide, transferList)
    },
    // 显示排序存储
    upcolumn(hide, sort) {
      // hide
      let COLUMN_HIDE = localStorage.getItem('COLUMN_HIDE')
      COLUMN_HIDE = JSON.parse(COLUMN_HIDE)
      if (!COLUMN_HIDE) COLUMN_HIDE = {}
      COLUMN_HIDE[this.id] = hide
      localStorage.setItem('COLUMN_HIDE', JSON.stringify(COLUMN_HIDE))
      // sort
      let COLUMN_SORT = localStorage.getItem('COLUMN_SORT')
      COLUMN_SORT = JSON.parse(COLUMN_SORT)
      if (!COLUMN_SORT) COLUMN_SORT = {}
      COLUMN_SORT[this.id] = sort
      localStorage.setItem('COLUMN_SORT', JSON.stringify(COLUMN_SORT))
      this.initConf()
    },
    // ----------------------------
    // 重新数据
    submitForm() {
      if (!this.isData) this.loadtableData()
    },
    // 查询表格
    sizeChange(pageSize) {
      this.pageNum = 1
      this.pageSize = pageSize
      this.submitForm()
    },
    // 查询表格
    currentChange(pageNum) {
      this.pageNum = pageNum
      this.submitForm()
    },
    // 查询表格
    async loadtableData() {
      try {
        this.tableloading = true
        const { list, total } = await this.tableHand({
          pageNum: this.isPage ? this.pageNum : 1,
          pageSize: this.isPage ? this.pageSize : 1000,
          tenantId: localStorage.getItem('tenantId')
        })
        this.tableData = list
        this.count = total
      } finally {
        this.tableloading = false
      }
      this.tableData.forEach(async (row) => {
        try {
          row.tableloading = true
          const { list = [], total = 0 } = (await this.subtableHand(row)) || {}
          row.list = list
          row.count = total
        } finally {
          row.tableloading = false
        }
      })
    },
    // 导出
    async handleDownload() {
      let config = this.column.filter((item) => !item.hide)
      let tHeader = config.map((crr) => crr.label)
      try {
        this.$notify.info({
          title: '导出中...',
          message: '数据将在稍后导出，请勿重复操作'
        })
        const { list } = await this.tableHand({
          pageNum: 1,
          pageSize: 1000,
          tenantId: localStorage.getItem('tenantId')
        })
        export_json_to_excel({
          header: tHeader,
          data: this.formatJson(config, list),
          filename: [this.name]
        })
      } catch {
        this.$notify.info({
          title: '导出失败',
          message: '数据导出失败'
        })
      }
    },
    // 导出数据
    formatJson(config, jsonData) {
      return jsonData.map((row) =>
        config.map((crr) => {
          if (crr.template) {
            return this.downHand(row, crr.template) || row[crr.template]
          } else {
            return row[crr.prop]
          }
        })
      )
    }
  }
}
</script>

<style>
/* 修复不对其 */
.el-table th.gutter {
  display: table-cell !important;
}
.el-table tr,
.el-table th,
.el-table tr.current-row,
.el-table tr.current-row > td,
.el-table th.el-table__cell {
  background: transparent;
}
.el-tabl e tr.select > td,
.el-table tr.select:hover > t,
.el-table tr.select > td.el-table__cell,
.el-table tr.select:hover > td.el-table__cell {
  background: #c9ea9deb;
}
.el-table tr > td.select,
.el-table tr:hover > td.select,
.el-table tr > td.select.el-table__cell,
.el-table tr:hover > td.select.el-table__cell {
  background: #088;
  color: white;
}
.el-table tr > td .blue {
  color: blue;
  cursor: pointer;
}
.el-table tr > td .red {
  color: red;
}
.el-table tr > td .gray {
  color: gray;
}
.el-table tr > td.select .blue,
.el-table tr > td.select .red,
.el-table tr > td.select .gray {
  color: white;
}
.el-table .el-table__expanded-cell {
  padding: 0px;
}
.el-table--enable-row-transition .el-table__body td {
  transition: none;
}
.el-icon-s-tools {
  color: #05c15f;
  font-size: 22px;
  vertical-align: middle;
}
.el-table__expand-column {
  overflow: hidden;
}
.scdialog .el-dialog {
  width: 902px;
}
.el-transfer-panel {
  width: 300px;
}
</style>

<style scoped>
.pagination {
  margin-top: 12px;
  display: flex;
}
.paginationtip {
  flex: 1;
  line-height: 32px;
  color: gray;
  font-size: 12px;
}
</style>
